import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { FeaturedBusinessesResponse } from "@/api/types";

export function useFeaturedBusinesses(limit = 6) {
  return useQuery({
    queryKey: ["businesses", "featured", limit],
    queryFn: () =>
      api
        .get("businesses/featured", { searchParams: { limit } })
        .json<FeaturedBusinessesResponse>(),
    staleTime: 5 * 60_000,
  });
}
